import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VuePageTitle from 'vue-page-title'

Vue.use(VuePageTitle, {
  suffix: '- GRAVITY'
})
Vue.config.productionTip = true
// Vue.prototype.$ip = '18.117.51.228'
Vue.prototype.$ip = '127.0.0.1'


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
